import graphql__6f831c62c3e3dabe422d from "./__generated__/SubscribeContactToListDialogMailingListsQuery.graphql.ts";
import graphql__0961b0d10abb09d5ee30 from "./__generated__/SubscribeContactToListDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import {useRelayEnvironment, fetchQuery} from "react-relay/hooks";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import asFormikField from "../abstract/asFormikField";
import AbstractCombobox from "../abstract/AbstractCombobox";

type Props = {
    contactIdentifier: string;
    handleCloseDialog: () => void;
}

const mailingListsDataProvider = (relayEnvironment) => {
    return AwesomeDebouncePromise((searchTerm: string = '') => {
        return fetchQuery(relayEnvironment, graphql__6f831c62c3e3dabe422d, {}).toPromise().then((data: any) => {
            if (!data) {
                return [];
            }
            const lists = data.mailingLists || [];
            if (!searchTerm) {
                return lists;
            }
            const searchLower = searchTerm.toLowerCase();
            return lists.filter((list) => list.name.toLowerCase().includes(searchLower));
        });
    }, 500);
}

const SubscribeContactToListDialog: React.FC<Props> = ({contactIdentifier, handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (values) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__0961b0d10abb09d5ee30,
                variables: {
                    input: {
                        mailingListIdentifier: values.mailingListIdentifier?.mailingListIdentifier || null,
                        contactIdentifier: contactIdentifier
                    }
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToSubscribeToList'})
            }
        )
    }

    const initialValues = {
        mailingListIdentifier: null
    }

    const validationSchema = yup.object().shape({
        mailingListIdentifier: yup.object()
            .required(intl.formatMessage({id: 'validation.field.required'})),
    });

    const MailingListCombobox = asFormikField(AbstractCombobox, 'mailingListIdentifier');

    return (
        <FormDialog handleCloseDialog={handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    headline={intl.formatMessage({id: 'dialog.SubscribeContactToListDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.add'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.SubscribeContactToListDialog.listLabel'})}</Label>
                    <MailingListCombobox
                        getEntryId={({mailingListIdentifier}) => mailingListIdentifier}
                        getEntryLabel={({name}) => name}
                        getEntrySecondaryLabel={({subscribedCount}) => `${subscribedCount} ${intl.formatMessage({id: 'marketingEmail.subscribers'})}`}
                        dataProvider={mailingListsDataProvider(relayEnvironment)}
                        placeholder={intl.formatMessage({id: 'dialog.SubscribeContactToListDialog.listPlaceholder'})}
                    />
                </Row>
            </Section>
        </FormDialog>
    )
}

export default SubscribeContactToListDialog;
